import { SharedVideoForm } from './SharedVideoForm';

export * from './SharedVideoForm';

export type SharedVideo = {
    id: string;

}

export type RecommendedVideo = {
}

export type VideosState = {
    videos: {
        shared: SharedVideo[],
        recommended: RecommendedVideo[]
    }
    form: {
        shared: SharedVideoForm,
        // recommeded: {}
    }
}

export const INITIAL_STATE: VideosState = {
    videos: {
        shared: [],
        recommended: []
    },
    form: {
        shared: {
            privacy: { value: 'private', errors: [] },
            title: { value: '', errors: [] },
            description: { value: '', errors: [] },
            video: { value: null, errors: [] },
        },
        // recommended: RecommendedForm
    }
}
